// Generated by scripts/sync-stripe-paywall-prices.mjs — do not edit by hand.
export default {
  "generatedAt": "2026-06-21T09:42:42.568Z",
  "source": "stripe",
  "stripeMode": "tier_catalog",
  "amounts": {
    "1": {
      "lernMonthly": 10,
      "lernYearly": 60,
      "eduMonthly": 20,
      "eduYearly": 120
    },
    "2": {
      "lernMonthly": 8,
      "lernYearly": 36,
      "eduMonthly": 15,
      "eduYearly": 96
    },
    "3": {
      "lernMonthly": 5,
      "lernYearly": 24,
      "eduMonthly": 10,
      "eduYearly": 60
    },
    "4": {
      "lernMonthly": 3,
      "lernYearly": 12,
      "eduMonthly": 5,
      "eduYearly": 24
    }
  },
  "prices": {
    "STRIPE_PRICE_T1_SOLO_MONTHLY": {
      "priceId": "price_1TZEhZLvfiTwQ1HhCUxTlwJT",
      "unitAmountCents": 1000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T1_SOLO_YEARLY": {
      "priceId": "price_1TZEqyLvfiTwQ1HhY07DS8Nm",
      "unitAmountCents": 6000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T1_EDU_MONTHLY": {
      "priceId": "price_1TgLrSLvfiTwQ1Hhj75w3IRM",
      "unitAmountCents": 2000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T1_EDU_YEARLY": {
      "priceId": "price_1TZEoNLvfiTwQ1Hh6wO6E28l",
      "unitAmountCents": 12000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_SOLO_MONTHLY": {
      "priceId": "price_1TgLopLvfiTwQ1HhH3n7CCkK",
      "unitAmountCents": 800,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_SOLO_YEARLY": {
      "priceId": "price_1TgLpALvfiTwQ1HhsotG1w4o",
      "unitAmountCents": 3600,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_EDU_MONTHLY": {
      "priceId": "price_1TZEjeLvfiTwQ1HhaerBYAER",
      "unitAmountCents": 1500,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_EDU_YEARLY": {
      "priceId": "price_1TgLrzLvfiTwQ1Hh7fOPsRZM",
      "unitAmountCents": 9600,
      "currency": "eur"
    },
    "STRIPE_PRICE_T3_SOLO_MONTHLY": {
      "priceId": "price_1TgLpSLvfiTwQ1HhvFuPRqUx",
      "unitAmountCents": 500,
      "currency": "eur"
    },
    "STRIPE_PRICE_T3_SOLO_YEARLY": {
      "priceId": "price_1TgLpkLvfiTwQ1HhgOhX0qfV",
      "unitAmountCents": 2400,
      "currency": "eur"
    },
    "STRIPE_PRICE_T3_EDU_MONTHLY": {
      "priceId": "price_1TgLslLvfiTwQ1HhhGbMBZpd",
      "unitAmountCents": 1000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T3_EDU_YEARLY": {
      "priceId": "price_1TgLtHLvfiTwQ1HhE8vMBWDM",
      "unitAmountCents": 6000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T4_SOLO_MONTHLY": {
      "priceId": "price_1TgLq2LvfiTwQ1HhmpAL5DvW",
      "unitAmountCents": 300,
      "currency": "eur"
    },
    "STRIPE_PRICE_T4_SOLO_YEARLY": {
      "priceId": "price_1TgLqLLvfiTwQ1HhmxrF9axq",
      "unitAmountCents": 1200,
      "currency": "eur"
    },
    "STRIPE_PRICE_T4_EDU_MONTHLY": {
      "priceId": "price_1TgLtsLvfiTwQ1Hhey3ab5wa",
      "unitAmountCents": 500,
      "currency": "eur"
    },
    "STRIPE_PRICE_T4_EDU_YEARLY": {
      "priceId": "price_1TgLueLvfiTwQ1HhgoF0AM1c",
      "unitAmountCents": 2400,
      "currency": "eur"
    }
  }
};
